import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';

import { EMPTY, Observable } from 'rxjs';
import { expand, reduce } from 'rxjs/operators';
import { AlertItem } from '../../interfaces/alerts.interface';
// import { AlertItem } from 'projects/angular-clarity/src/app/interfaces/alerts.interface';

const headers = {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    'Access-Control-Allow-Origin': '*',
};

@Injectable()
export class AlertDataService extends DefaultDataService<AlertItem[]> {
    constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
        super('Alert', http, httpUrlGenerator);
    }

    private fetchWithPaging<T>(msp: string, tenant: string, start: string, end: string): Observable<any[]> {
        const encodedStart = encodeURIComponent(start);
        const encodedEnd = encodeURIComponent(end);
        return this.http
            .get(`/api/octiga/v3/tenant/alerts?start=${encodedStart}&end=${encodedEnd}`, {
                headers: {
                    ...headers,
                    'msp-id': msp,
                    'tenant-id': tenant,
                },
            })
            .pipe(
                expand((data: any) => {
                    if (data.LastEvaluatedKey) {
                        const lek = encodeURIComponent(JSON.stringify(data.LastEvaluatedKey));
                        return this.http.get<{ Items?: T[] }>(
                            `/api/octiga/v3/tenant/alerts?start=${encodedStart}&end=${encodedEnd}&LastEvaluatedKey=${lek}`,
                            {
                                headers: {
                                    ...headers,
                                    'msp-id': msp,
                                    'tenant-id': tenant,
                                },
                            },
                        );
                    } else {
                        return EMPTY;
                    }
                }),
                reduce((acc, data: any) => (data.Items ? acc.concat(data.Items) : acc.concat(data)), []),
            );
    }

    override getWithQuery(params: { msp: string; tenant: string; start: string; end: string }) {
        const { msp, tenant, start, end } = params;
        return this.fetchWithPaging<AlertItem[]>(msp, tenant, start, end);
    }
}
